import { render, staticRenderFns } from "./individualAccountForm.vue?vue&type=template&id=2b0b726a&"
import script from "./individualAccountForm.vue?vue&type=script&lang=js&"
export * from "./individualAccountForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports